import React from 'react';
import { useState, useEffect } from 'react';
import { flowRight } from 'lodash/fp';
import { withRouter } from 'react-router-dom';
import { withSnackbar } from 'notistack';

import UserForm from './UserForm';
import { loadUserInfo, loadCompany } from './services';

let ViewUser = props => {
    const { match } = props;
    const { id, company_id: companyId } = match.params;
    const [currentUser, setCurrentUser] = useState(null);
    const [additionalData, setAdditionalData] = useState({
        portalUsers: [],
        companyGroups: [],
        roles: [],
    });

    useEffect(() => {
        loadUserInfo(id, companyId).then(({ user, roles, groups }) => {
            setCurrentUser(user);
            setAdditionalData({
                roles,
                companyGroups: groups,
            });
            loadCompany(companyId).then(company =>
                props.updateBreadcrumbs([
                    { name: 'Companies', path: '/companies' },
                    {
                        name: company.business_name,
                        path: `/companies/${companyId}`,
                    },
                    `${user.first_name} ${user.last_name}`,
                ])
            );
        });
    }, []);

    if (currentUser) {
        return (
            <UserForm
                editable={false}
                currentUser={currentUser}
                additionalData={additionalData}
                companyId={companyId}
            />
        );
    }
    return <div />;
};

export default flowRight(withSnackbar, withRouter)(ViewUser);
